import withTracker from './withTracker';
import NotFound from '../containers/NotFound';

const notfound = {
  path: '/notfound',
  component: withTracker(NotFound)
};

export default notfound;
